( function( $ ) {

var pageId = 'page-member',
    page = '#' + pageId;

$( function() {

    $('body')
    .on('click', page + ' .select-all-cal', function(e) {
        e.preventDefault();
        $('.cal-in input[type=checkbox]').prop('checked', true);
    })
    .on('click', page + ' .select-none-cal', function(e) {
        e.preventDefault();
        $('.cal-in input[type=checkbox]').prop('checked', false);
    })
    .on('click', page + ' .select-all-repo', function(e) {
        e.preventDefault();
        $('.repo-in input[type=checkbox]:enabled').prop('checked', true);
    })
    .on('click', page + ' .select-none-repo', function(e) {
        e.preventDefault();
        $('.repo-in input[type=checkbox]:enabled').prop('checked', false);
    })
    .on('click', page + ' .select-all-proj', function(e) {
        e.preventDefault();
        $('tr-project-checkboxes').get(0).selectAll()
    })
    .on('click', page + ' .select-none-proj', function(e) {
        e.preventDefault();
        $('tr-project-checkboxes').get(0).unselectAll()
    })
    .on('click', page + ' .select-all-group', function(e) {
        e.preventDefault();
        $('.group-in input[type=checkbox]').prop('checked', true);
    })
    .on('click', page + ' .select-none-group', function(e) {
        e.preventDefault();
        $('.group-in input[type=checkbox]').prop('checked', false);
    })
    .on('click', page + ' .select-all-question', function(e) {
        e.preventDefault();
        $('.question-in input[type=checkbox]:enabled').prop('checked', true);
    })
    .on('click', page + ' .select-none-question', function(e) {
        e.preventDefault();
        $('.question-in input[type=checkbox]:enabled').prop('checked', false);
    })
    .on( "ajax:beforeSend", page + " #link-remove-member", function( e ) {
        simple.loading({
            type: 'global',
            msg: '正在移除...'
        });
    })
    .on('ajax:success', page + ' #link-remove-member', function(e, result) {
        simple.loading.destroy();
        if ( result.msg ) {
            var dialog = simple.dialog({
                content: result.msg,
                width: 450,
                buttons: [{
                    text: "知道了",
                    callback: function(e) {
                        dialog.remove();
                        $('#nav-members > a').trigger('click');
                        // TODO: need to be fixed
                    }
                }]
            });
        } else {
            window.location.href = result.redirect_path;
        }
    })
    .on( "ajax:error", page + " #link-remove-member", function( e ) {
        simple.loading.destroy();
    });
});

})( jQuery );
